"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
function getAuthorizationHeaders(accessToken, source) {
    return {
        'Content-Type': 'application/json; charset=UTF-8',
        Authorization: `Bearer ${accessToken}`,
        'x-source': source
    };
}
exports.getAuthorizationHeaders = getAuthorizationHeaders;
function getData(api, path, requestObject, type = 'POST', requestWrappingEnabled = false, additionalOptions = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        let isConnected = false;
        try {
            isConnected = yield Promise.resolve(navigator.onLine);
        }
        catch (e) {
            return Promise.reject(new Error(JSON.stringify({})));
        }
        let formattedRequestObject = requestObject;
        if (isConnected === true) {
            let response;
            if (requestWrappingEnabled) {
                const stringifiedRequestObject = JSON.stringify(JSON.stringify(requestObject));
                const dataRequestObject = JSON.stringify({
                    data: stringifiedRequestObject,
                    clientKeyDetailsId: 1
                });
                formattedRequestObject = dataRequestObject;
            }
            const { cancelToken } = additionalOptions;
            let otherOptions = {};
            if (cancelToken) {
                otherOptions = { cancelToken: cancelToken };
            }
            switch (type) {
                case 'POST':
                    response = yield api.post(path, formattedRequestObject, otherOptions);
                    if (response.ok === false) {
                        throw Error(JSON.stringify(response));
                    }
                    return response.data;
                case 'GET':
                    response = yield api.get(path, {}, otherOptions);
                    if (response.ok === false) {
                        throw Error(JSON.stringify(response));
                    }
                    return response.data;
                case 'PUT':
                    response = yield api.put(path, formattedRequestObject, otherOptions);
                    if (response.ok === false) {
                        throw Error(JSON.stringify(response));
                    }
                    return response.data;
                case 'DELETE':
                    response = yield api.delete(path, {}, otherOptions);
                    if (response.ok === false) {
                        throw Error(JSON.stringify(response));
                    }
                    return response.data;
                default:
            }
        }
        else {
            const response = {
                ok: false,
                config: {},
                duration: 0,
                headers: {},
                problem: 'NETWORK_DISCONNECTED',
                status: 503,
                data: {
                    res_status: '',
                    response: '',
                    http_status_code: 503
                }
            };
            throw Error(JSON.stringify(response));
        }
        return Promise.resolve(null);
    });
}
exports.default = getData;
//# sourceMappingURL=index.js.map